import { render, staticRenderFns } from "./Dominance.vue?vue&type=template&id=e7b012dc&"
import script from "./Dominance.vue?vue&type=script&lang=js&"
export * from "./Dominance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports